import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsSelfTriageService } from 'src/app/self-triage/utils.service';
import { SelfTriageScreenEnum } from 'src/app/shared/enum/self-triage/self-triage-screen.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { PatientQRCodeAccessSelfTriageService } from 'src/app/shared/services/API/orchestrator-patient/patient-qr-code-access-self-triage.service';
import { ClientSelfTriageProtocolService } from 'src/app/shared/services/API/self-triage/client-self-triage-protocol.service';
import { SelfTriageProtocolService } from 'src/app/shared/services/API/self-triage/self-triage-protocol.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { DirectionButton } from 'src/app/shared/services/models/self-triage/direction-button.model';
import { Patient } from 'src/app/shared/services/models/self-triage/patient.models';
import { SelfTriageCounselingModel } from 'src/app/shared/services/models/self-triage/self-triage-counseling.model';
import { PatientRequest } from 'src/app/shared/services/requests/self-triage/patient.request';
import { SelfTriageResultRequest } from 'src/app/shared/services/requests/self-triage/self-triage-result.request';
import { GetProtocolSessionResponse } from 'src/app/shared/services/responses/self-triage/get-protocol-session.response';
import { FlowchartCompleteStruct } from 'src/app/shared/services/structs/self-triage/flowchart-complete.struct';
import { ProtocolCompleteStruct } from 'src/app/shared/services/structs/self-triage/protocol-complete.struct';
import { QuestionAnswerStruct } from 'src/app/shared/services/structs/self-triage/question-answer.struct';
import { QuestionStruct } from 'src/app/shared/services/structs/self-triage/question.struct';
import { SelfTriageConfigStruct } from 'src/app/shared/services/structs/self-triage/self-triage-config.struct';
import { ResumeModalComponent } from '../counseling/resume-modal/resume-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AlertModalComponent } from 'src/app/shared/components/alert-modal/alert-modal.component';
import { BirthDateModalComponent } from './birth-date-modal/birth-date-modal.component';
import { UtilService } from 'src/app/shared/services/util.service';
import { QRCode } from 'src/app/shared/services/models/totem/nps-message.model';

@Component({
  selector: 'app-protocol',
  templateUrl: './protocol.component.html',
  styleUrls: ['./protocol.component.css']
})

export class ProtocolComponent implements OnInit {
  constructor(private alertService: AlertService,
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    private clientSelfTriageProtocolService: ClientSelfTriageProtocolService,
    private selfTriageProtocolService: SelfTriageProtocolService,
    private patientQRCodeAccessSelfTriageService: PatientQRCodeAccessSelfTriageService,
    private maskService: MaskService,
    private activatedRoute: ActivatedRoute,
    private utilSelfTriageService: UtilsSelfTriageService,
    public router: Router,
    private datepipe: DatePipe,
    private utilService: UtilService,
  ) { }

  public evaluationModel: FormGroup;
  public counselingModel: FormGroup;
  public masks: Masks;

  public uri: string;
  public colorCode: string = '#99C8D6';

  public selfTriageConfig: SelfTriageConfigStruct;
  public protocol: ProtocolCompleteStruct = null;
  public patient: Patient;
  public counseling: SelfTriageCounselingModel;
  public flowchart: FlowchartCompleteStruct;
  public question: QuestionStruct;
  public qrCode: QRCode;
  public questionsHistoric: QuestionStruct[] = [];
  public results: QuestionAnswerStruct[] = [];
  public listButtons: DirectionButton[] = [];

  public patientCenterAccessSelfTriage: boolean = false;
  public flowchartSelected: boolean = false;
  public selectedCounseling: boolean = false;
  public isTriageFinished: boolean = false;
  public protocolSelected: boolean = false;
  public isLoading: boolean = true;
  public idEpisode: number = null;
  public idHealthUnit: number = null;

  public thisScreen: SelfTriageScreenEnum = SelfTriageScreenEnum.evaluation;
  public idSelfTriagePatient: number;

  birthDate: Date = null;

  ngOnInit(): void {
    this.masks = this.maskService.getMasks();
    this.selfTriageConfig = this.utilSelfTriageService.getSelfTriageConfigStruct();
    this.uri = this.utilSelfTriageService.getUri();
    this.patientCenterAccessSelfTriage = this.utilSelfTriageService.getSelfTriageAccessSelfTriage();
    this.qrCode = this.utilService.getQRCodeConfig();

    this.activatedRoute.paramMap.subscribe(params => {
      this.idEpisode = Number(params.get('idEpisode'));
    });

    if (this.idEpisode) {
      this.getConfigAndValidationEpisode();

      if (this.selfTriageConfig) {
        this.colorCode = this.selfTriageConfig.colorCode;
        document.documentElement.style.setProperty('--colorCodeSelfTriage', this.colorCode);
      }
    }

    if (this.patientCenterAccessSelfTriage)
      this.selfTriageConfig = this.utilSelfTriageService.getSelfTriageConfig();

    if (!this.idEpisode) {
      if (!this.selfTriageConfig)
        this.router.navigate([`self-triage/${this.utilSelfTriageService.getUri()}`]);
      else if (this.selfTriageConfig.useColor == true) {
        this.colorCode = this.selfTriageConfig.colorCode;
        document.documentElement.style.setProperty('--colorCodeSelfTriage', this.colorCode);
      }

      this.patient = this.utilSelfTriageService.getPatientData();
      if (this.patient) {
        this.idSelfTriagePatient = this.patient.idPatient;
        this.protocolClient(this.patient.birthDate);
      }
      else
        this.router.navigate([`self-triage/${this.utilSelfTriageService.getUri()}`]); //VERIFICAR ALGUMA MENSAGEM DE ERRO
    }

    this.evaluationModel = this.formBuilder.group({
      questionAnswerHistory: this.formBuilder.array([]),
      selectedCounseling: [false, [Validators.requiredTrue]]
    });

    this.counselingModel = this.formBuilder.group({
      idCounseling: [null],
      listIdDirectionButton: [null],
    });
  }

  goRedirectPage() {
    this.router.navigate([`welcome/redirect-page/${this.qrCode.guid}`]);
  }

  selectedFlowchart(idFlowchart: number) {
    let flowchart: FlowchartCompleteStruct = this.protocol.listFlowchart.find(x => x.idFlowchart == idFlowchart);
    this.flowchart = flowchart;
    this.question = flowchart.question;
    this.flowchartSelected = true;
  }

  flowchartNoConfigured() {
    this.flowchartSelected = false;
  }

  selectedQuestion({ question, answer }) {
    let questionAnswer: QuestionAnswerStruct = {
      idQuestion: this.question.idQuestion,
      statement: this.question.statement,
      idAnswer: answer.idAnswer,
      answer: answer.answer
    };

    this.results.push(questionAnswer);
    this.addQuestionAnswer(questionAnswer);
    this.questionsHistoric.push(this.question);
    this.question = question;
  }

  addQuestionAnswer(questionAnswer: Object) {
    (this.evaluationModel.controls['questionAnswerHistory'] as FormArray)
      .push(this.createQuestionAnswer(questionAnswer));
  }

  createQuestionAnswer(questionAnswer: any) {
    return this.formBuilder.group({
      question: [questionAnswer.question],
      answer: [questionAnswer.answer],
    });
  }

  goBack() {
    this.flowchart = null;
    this.question = null;
    this.flowchartSelected = false;
    this.selectedCounseling = false;
    this.results = [];
    this.isTriageFinished = false;
    this.evaluationModel.get('selectedCounseling').setValue(false);
  }

  selectCounseling({ counseling, answer }) {
    this.results.push({
      idQuestion: this.question.idQuestion,
      statement: this.question.statement,
      idAnswer: answer.idAnswer,
      answer: answer.answer
    });

    this.selectedCounseling = true;
    this.counseling = counseling;
  }

  finishFlowchart() {
    this.isLoading = true;
    this.evaluationModel.get('selectedCounseling').setValue(true);
    this.evaluationModel.get('selectedCounseling').updateValueAndValidity();
    let listIdButtons = this.selfTriageConfig.listCounselingDirection.find(x => x.idSelfTriageCounseling == this.counseling.idSelfTriageCounseling)?.listIdDirectionButton;
    if (this.counseling.idSelfTriageCounseling && this.counseling.idSelfTriageCounseling != 0)
      this.counselingModel.get('idCounseling').setValue(this.counseling.idSelfTriageCounseling);
    if (listIdButtons) {
      this.counselingModel.get('listIdDirectionButton').setValue(listIdButtons);
      this.listButtons = this.selfTriageConfig.listButtons.filter(x => listIdButtons.includes(x.idDirectionButton));
    }
    // stepper.next();

    let request: SelfTriageResultRequest = new SelfTriageResultRequest;
    request.flowchart = this.flowchart.name;
    request.idFlowchart = this.flowchart.idFlowchart;
    request.counseling = this.counseling.selfTriageCounselingName;
    request.idCounseling = this.counseling.idSelfTriageCounseling;
    request.idPatient = this.idSelfTriagePatient ?? this.patient.idPatient;
    request.listQuestionAnswer = this.results;
    request.patientRegisterRequest = new PatientRequest();
    request.patientRegisterRequest = this.mapperPatientData();

    if (this.patientCenterAccessSelfTriage) {
      this.selfTriageProtocolService.SaveSelfTriageResult(this.uri, request).subscribe({
        next: (response) => {
          if (response.isError) {
            this.isLoading = false;
            this.alertService.show("Erro", "Houve um erro ao tentar salvar sua classificação!", AlertType.error);
            return;
          }

          this.patient.idPatient = response.idPatient;
          this.utilSelfTriageService.updatePatientData(this.patient);
          this.mapperCounseling();
        },
        error: (error) => {
          console.log(error);
        }
      });
    }
    else if (this.idEpisode) {
      request.idEpisode = this.idEpisode;
      request.idHealthUnit = this.selfTriageConfig.idHealthUnit;
      request.patientRegisterRequest.birthDate = this.birthDate ?? this.patient.birthDate;

      this.clientSelfTriageProtocolService.SavePatientQRCodeSelfTriage(request).subscribe({
        next: (response) => {
          if (response.isError) {
            this.isLoading = false;
            this.alertService.show("Erro", "Houve um erro ao tentar salvar sua classificação!", AlertType.error);
            return;
          }

          this.thisScreen = SelfTriageScreenEnum.end;
          this.isTriageFinished = true;
          this.isLoading = false;
        },
        error: (error) => {
          console.log(error);
          this.alertService.show("Erro", "Houve um erro ao tentar salvar sua classificação!", AlertType.error);
          return;
        }
      });
    }
    else {
      this.clientSelfTriageProtocolService.SaveSelfTriageResult(this.uri, request).subscribe({
        next: (response) => {
          if (response.isError) {
            this.isLoading = false;
            this.alertService.show("Erro", "Houve um erro ao tentar salvar sua classificação!", AlertType.error);
            return;
          }

          this.mapperCounseling();
        },
        error: (error) => {
          console.log(error);
          this.alertService.show("Erro", "Houve um erro ao tentar salvar sua classificação!", AlertType.error);
          return;
        }
      });
    }
  }

  protocolClient(birthDate: Date) {
    this.clientSelfTriageProtocolService.getClientProtocol(this.uri, this.datepipe.transform(birthDate, 'yyyy-MM-dd')).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.protocol = new ProtocolCompleteStruct()
        this.protocol = response.protocol;
        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getConfigAndValidationEpisode() {
    this.patientQRCodeAccessSelfTriageService.getConfigAndValidationEpisode(this.idEpisode, this.birthDate).subscribe({
      next: (response) => {
        if (response.isError) {
          if (response.errorCode === 3) {
            this.utilSelfTriageService.setSelfTriageConfig(response.selfTriageConfig);
            this.selfTriageConfig = response.selfTriageConfig;
            this.colorCode = this.selfTriageConfig.colorCode;
            document.documentElement.style.setProperty('--colorCodeSelfTriage', this.colorCode);
            this.alertPatientAlreadySelfTriageModal();
            this.thisScreen = SelfTriageScreenEnum.end;
            this.isTriageFinished = true;
            this.selectedCounseling = true;
            this.flowchartSelected = true;
            this.isLoading = false;
            return;
          }
          else if (response.errorCode === 2) {
            this.utilSelfTriageService.setSelfTriageConfig(response.selfTriageConfig);
            this.selfTriageConfig = response.selfTriageConfig;
            this.colorCode = this.selfTriageConfig.colorCode;
            document.documentElement.style.setProperty('--colorCodeSelfTriage', this.colorCode);
            this.insertBirthDate();
            this.isLoading = false;
            return;
          }

          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.protocol = new ProtocolCompleteStruct()

        this.utilSelfTriageService.setSelfTriageConfig(response.selfTriageConfig);
        this.selfTriageConfig = response.selfTriageConfig
        this.colorCode = this.selfTriageConfig.colorCode;
        document.documentElement.style.setProperty('--colorCodeSelfTriage', this.colorCode);
        this.protocol = response.protocol;
        this.patient = response.patient;
        this.utilSelfTriageService.updatePatientData(this.patient);
        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  mapperPatientData() {
    let patientRegisterRequest = new PatientRequest();
    let patient = this.utilSelfTriageService.getPatientData();

    if (patient != null) {
      patientRegisterRequest.patientName = patient.patientName;
      patientRegisterRequest.cpf = patient.cpf;
      patientRegisterRequest.phone = patient.phone;
      patientRegisterRequest.email = patient.email;
      patientRegisterRequest.birthDate = patient.birthDate;
      patientRegisterRequest.idGender = patient.idGender;
      patientRegisterRequest.city = patient.city;
      patientRegisterRequest.state = patient.state;
      patientRegisterRequest.neighborhood = patient.neighborhood;
      patientRegisterRequest.idHealthUnit = this.selfTriageConfig.idHealthUnit;
      patientRegisterRequest.listIdHealthUnit = this.selfTriageConfig.listIdHealthUnit;
    }

    return patientRegisterRequest;
  }

  mapperCounseling() {
    this.protocolSelected = true;
    this.isTriageFinished = true;

    let counselingConfigSession: GetProtocolSessionResponse = new GetProtocolSessionResponse();
    counselingConfigSession.counseling = this.counseling;
    counselingConfigSession.listButtons = this.listButtons;
    counselingConfigSession.flowchart = this.flowchart;
    counselingConfigSession.results = this.results;
    this.utilSelfTriageService.setProtocolResponse(counselingConfigSession);

    this.router.navigate([`self-triage/counseling/${this.utilSelfTriageService.getUri()}`]);
  }

  openResume() {
    const dialogRef = this.dialog.open(ResumeModalComponent, {
      autoFocus: false,
      width: '500px',
      panelClass: 'results-modal',
      data: {
        results: this.results,
        flowchart: this.flowchart,
        counseling: this.counseling.counseling,
        colorCode: this.colorCode,
        idEpisode: this.idEpisode
      },
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  alertPatientAlreadySelfTriageModal() {
    this.dialog.open(AlertModalComponent, {
      disableClose: true,
      data: {
        title: 'Alerta',
        description: 'O paciente já realizou a Autotriagem para este episódio.',
        colorCode: this.colorCode,
        hasButton: false
      },
    });
  }

  insertBirthDate() {
    const dialogAlert = this.dialog.open(BirthDateModalComponent, {
      disableClose: true,
      data: {
        colorCode: this.colorCode,
      },
    });
    dialogAlert.afterClosed().subscribe({
      next: result => {
        this.birthDate = result.birthDate;
        this.getConfigAndValidationEpisode();
      }
    });
  }
}